export enum PublicTransportImportType {
    TransitLand = 1,

    Traveline = 2,

    AtocCif = 3,

    Gtfs = 4,

    NCSD = 5,

    Translink = 6,

    BoundaryVectorTiles = 7,

    UsTransit = 8,

    UsTransitMerge = 9
}

export const getPublicTransportImportTypeLabel = (
    importType: PublicTransportImportType
) => {
    switch (importType) {
        case PublicTransportImportType.AtocCif:
            return "ATOC";
        case PublicTransportImportType.Traveline:
            return "Traveline";
        case PublicTransportImportType.TransitLand:
            return "TransitLand";
        case PublicTransportImportType.NCSD:
            return "NCSD";
        case PublicTransportImportType.BoundaryVectorTiles:
            return "BoundaryVectorTiles";
        case PublicTransportImportType.UsTransit:
            return "US Transit";
        case PublicTransportImportType.UsTransitMerge:
            return "Us Transit Merge";
    }
};
